var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeWarn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9242_173943)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73333 5C10.1383 5 10.4667 5.3652 10.4667 5.81573V10.0928C10.4667 10.5433 10.1383 10.9085 9.73333 10.9085C9.32833 10.9085 9 10.5433 9 10.0928V5.81573C9 5.3652 9.32833 5 9.73333 5ZM9.73333 12.5143C10.1383 12.5143 10.4667 12.8795 10.4667 13.33V13.7176C10.4667 14.1681 10.1383 14.5333 9.73333 14.5333C9.32833 14.5333 9 14.1681 9 13.7176V13.33C9 12.8795 9.32833 12.5143 9.73333 12.5143Z",
    fill: "#FA992B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 18,
    rx: 9,
    stroke: "#FA992B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9242_173943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeWarn);
export default __webpack_public_path__ + "static/media/orange-warn.589e6b8b22eeedf4a49a092ef723b4bd.svg";
export { ForwardRef as ReactComponent };